import React from 'react';

function TaskDetailPage() {
  return <div className="page-container"><h1>Task Details</h1><p>Task detail view coming soon...</p></div>;
}

export default TaskDetailPage;
